'use client';

import { ComponentProps } from 'react';

import { Dialog as OriginalDialog } from '@bgzt/ui';

type Props = ComponentProps<typeof OriginalDialog>;

/**
 * NOTICE
 * useOverlay를 사용해서 제어하세요!
 * **/

export const Dialog = ({ isOpen, onClose: handleClose, ...props }: Props) => {
  return (
    <OriginalDialog
      isOpen={isOpen}
      onClose={() => {
        handleClose();
      }}
      {...props}
    />
  );
};
